import {Utils, Jqext} from '../../app.base'
import {Vue, MsgBox} from '../../app.vues'

let Toast = Jqext.Toast;
//
import SwbDbColSelect from './DbColSelect.vue'

Vue.regist(SwbDbColSelect);

//callback(selColList)
export function showDbColSelectDlg(config, callback) {
    config = config || {};

    let dlgTitle = config['dlgTitle'] || '从库表【{0}】选择列';
    let tableName = config['tableName'] || null;
    let iniSelected = config['iniSelected'] || [];
    let iniSelectedVisible = config['iniSelectedVisible'] || false;

    Vue.$showDialog({
        title: dlgTitle.format(tableName),
        width: 940,//80%
        height: -100,//80%
        centerButtons: true,
        showCloseBtn: true,
        //
        template: '<swb-db-col-select ref="the-list-ctrl" :style="{ height: listCtrlHgt +\'px\'}" :table-name="tableName" :ini-selected="iniSelected" :ini-selected-visible="iniSelectedVisible"></swb-db-col-select>',
        data: {
            tableName: tableName,
            iniSelected: iniSelected,
            iniSelectedVisible: iniSelectedVisible,
            //
            listCtrlHgt: 800
        },
        methods: {
            //监听对话框内容大小（也可直接调用 内建的方法 getDlgBodySize() 获取）
            dlgBodyResized(width, height) {
                this.listCtrlHgt = height;
            }
        },
        okClicked: function () {
            let theCtrl = this.$refs['the-list-ctrl'];
            let selColList = theCtrl.getSelected();
            if (selColList == null || selColList.length == 0) {
                Toast.show('没有选择列', 5000, 'warning');
                return false;
            }
            if (typeof callback == 'function') {
                callback(selColList);
                //
                return true;
            }
            //
            return false;
        }
    });

}


//
import SwbQuerySortArea from './QuerySortArea.vue';

Vue.regist(SwbQuerySortArea);

export function showMetaQueryPreviewDlg(title, metaConfig) {
    title = title || '查询配置 - 预览';
    metaConfig = metaConfig || {};
    Vue.$showDialog({
        title: title,
        width: -200,//80%
        height: 600,//80%
        okVisible: false,
        cancelVisible: false,
        centerButtons: true,
        showCloseBtn: true,
        //
        template: '<swb-query-sort-area :config="metaConfig"></swb-query-sort-area>',
        data: {
            metaConfig: metaConfig
        },
    });
}

let __sample_data4type = {
    "string": ['金色漫香苑店', '时代风帆店', '大兴龙湖店', '万源店', '鲁谷店', '德胜门店', '甘露园店', '天通苑店', '华贸品超市店', '榆垡店'],
    "integer": [30, 2300, 400, 870, 3740, 4995, 800, 3500, 7980, 20000],
    "float": [3.4, 3.455, 34.00, 2748.874, 645.33, 2984, 8.344, 874.00, 8374, 8777.344],
    "date": ['2019-01-11 13:23:22', '2019-03-12 06:12:03', '2019-05-14 09:30:00', '2019-01-02 14:50:00', null, '2019-11-11 10:45:20', '2019-12-28 15:15:03', '2019-10-22 18:10:25', '2020-02-29 17:15:50', '2020-01-19 12:10:00'],
    "bool": [false, true, false, false, true, null, false, true, false, true]
};

function mockResultRowBy(colList, index) {
    let retRow = {};
    let colConf = null;
    let dataType = null;
    let sampleList = null;
    for (let i = 0, c = colList.length; i < c; i++) {
        colConf = colList[i];
        dataType = colConf.dataType;
        sampleList = __sample_data4type[dataType];
        retRow[colConf.name] = sampleList[index];
    }
    //
    return retRow;
}

//string, integer, float, date, bool
function mockResultTableData(colList, rowCount = 10) {
    colList = colList || [];
    rowCount = rowCount || 10;
    //
    let tableData = [];
    for (let i = 0; i < rowCount; i++) {
        tableData[i] = mockResultRowBy(colList, i);
    }
    //
    return tableData;
}

import SwbResultTable from './ResultTable.vue';

Vue.regist(SwbResultTable);

export function showMetaResultPreviewDlg(title, metaConfig, extraConfig) {
    title = title || '结果配置 - 预览';
    metaConfig = metaConfig || {};
    extraConfig = extraConfig || {};
    let needPager = extraConfig['needPager'] != false;
    let multiSelect = extraConfig['multiSelect'] == true;
    let rowNoShow = extraConfig['rowNoShow'] == true;
    let rowNoAsSeqNo = extraConfig['rowNoAsSeqNo'] != false;
    let rowNoFixed = extraConfig['rowNoFixed'] == true;
    let btnColFlag = extraConfig['btnColFlag'] != false;
    let btnColFixed = extraConfig['btnColFixed'] != false;
    //
    Vue.$showDialog({
        title: title,
        width: -200,//80%
        height: 600,
        okVisible: false,
        cancelVisible: false,
        centerButtons: true,
        showCloseBtn: true,
        //
        template: '<swb-result-table ref="thePreviewResult" :config="metaConfig" :needPager="needPager" :multiSelect="multiSelect" :rowNoShow="rowNoShow" :rowNoAsSeqNo="rowNoAsSeqNo" :rowNoFixed="rowNoFixed" :height="theHeight" :btnColName="btnColName" :btnColFixed="btnColFixed"></swb-result-table>',
        data: {
            metaConfig: metaConfig,
            //
            needPager: needPager,
            multiSelect: multiSelect,
            rowNoShow: rowNoShow,
            rowNoAsSeqNo: rowNoAsSeqNo,
            rowNoFixed: rowNoFixed,
            btnColName: btnColFlag ? 'actions' : null,
            btnColFixed: btnColFixed,
            //
            theHeight: '100%'
        },
        lifecycle: {
            mounted: function () {//推荐在此初始化
                this.theHeight = this.getDlgBodySize().height;
                //
                let thePreviewResult = this.$refs['thePreviewResult'];
                let usedColList = thePreviewResult.getUsedColList();
                let mockTableData = mockResultTableData(usedColList);
                thePreviewResult.render(mockTableData);
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/query/dialog.js
// module id = 234
// module chunks = 0